import React from 'react'
import { useState, useEffect } from 'react';
import { isPlatform } from '@ionic/react';
import { Camera, CameraResultType, CameraSource, Photo } from '@capacitor/camera';
import { Filesystem, Directory } from '@capacitor/filesystem';
import { Storage } from '@capacitor/storage';
import { Capacitor } from '@capacitor/core';
import { UserPhoto } from '../../../@types/usePhotoGallery';
import {isFromCamera} from '../../../store/requiredDocuments/actions/isFromCamera'
import { useDispatch, useSelector } from 'react-redux';
import { selectUser } from "../../../store/userAuthentication/selectors/selectUser";

export function usePhotoGallery() {
  const user = useSelector(selectUser);
    const dispatch = useDispatch();
    const [photos, setPhotos] = useState<UserPhoto[]>([]);
    const[photoInfo, setPhotoInfo] = useState<UserPhoto[]>([]);
  
    const takePhoto = async (categoryName : number) => {

      try{ const photo = await Camera.getPhoto({
        resultType: CameraResultType.Uri,
        source: CameraSource.Camera,
        quality: 50,
      });
      const fileName = new Date().getTime() + '.jpg';
      if(photos.filter(photo => photo.category === categoryName).length != 0 ) {
        const selectedIndex = photos.findIndex(photo => photo.category === categoryName)
         const replace = [...photos]
         replace[selectedIndex] = 
            {
                filepath: fileName,
                webviewPath: photo.webPath,
                category: categoryName,
            }
          setPhotos(replace);
          dispatch(isFromCamera(categoryName))
        }else{
            const newPhotos = [
                ...photos,
                {
                    filepath: fileName,
                    webviewPath: photo.webPath,
                    category: categoryName,
                },
              ];
              setPhotos(newPhotos);
              dispatch(isFromCamera(categoryName))
        }
        const newFileHolder = [
          {
            filepath: fileName,
            webviewPath: photo.webPath,
            category: categoryName,
            userId: user?.id
          },
        ];
        setPhotoInfo(newFileHolder);

    }catch (e) {
        console.log(e)
    }
    }
    return {
        photos,
        photoInfo,
        takePhoto,
      };
  }